module.exports = __webpack_public_path__ + "static/media/AttendedOne.9c28f6ff.png";